import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { usePageContext } from "./hooks/usePageContext"


function Seo({ description, meta, title, image}) {
  const {lang, paths, languages} = usePageContext()
  
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            supportedLanguages
            siteUrl
          }
        }
      }
    `
  )
  
  const metaImage = image ? image : `${site.siteMetadata.siteUrl}/images/og-fallback.jpg`
  const logo = `${site.siteMetadata.siteUrl}/images/audiodesires-logo_white.png`
  const metaDescription = description || site.siteMetadata.description


  return (
    
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title}
        titleTemplate={`%s ― ${site.siteMetadata.title}`}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:site_name`,
            content: `${site.siteMetadata.title} ― erotic audio stories`,
          },
          {
            property: `og:url`,
            content: `${site.siteMetadata.siteUrl}${paths[lang] || paths.originalPath}`,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:locale`,
            content: lang,
          },
          {
            property: `og:logo`,
            content: logo,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            property: `og:image`,
            content: metaImage,
          },
          {
            name: `twitter:card`,
            content: `summary_large_image`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
          {
            name: `twitter:image`,
            content: metaImage,
          },
        ].concat(meta)}
      > 
    {/* how to do hrefLangs: https://ahrefs.com/blog/hreflang-tags/ */}
    {languages.includes('en') ? 
      <link 
            rel='alternate'
            hrefLang='x-default'
            href={`${site.siteMetadata.siteUrl}${paths.en || paths.originalPath}`} 
        /> 
      : 
      <link 
            rel='alternate'
            hrefLang='x-default'
            href={`${site.siteMetadata.siteUrl}${paths[lang]}`} 
        /> 
    }
    
    {languages.map((supportedLang, index) => {
      // Don't create a link for the current language
      return paths[supportedLang] && (
        <link 
          key={index}
          rel='alternate'
          hrefLang={supportedLang}
          href={`${site.siteMetadata.siteUrl}${paths[supportedLang]}`} 
        />
      )
    })} 
      {/* <script src="https://analytics.ahrefs.com/analytics.js" data-key="dBD+/XRvyjc+Cg5r8WLDlQ" async></script> */}
      </Helmet>
    )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
